module.exports = __webpack_public_path__ + "assets/img/aiwriter-bus4.3eac0e22.png";